import { useEffect, useState } from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { usePDFSlick } from '@pdfslick/react';
import '@pdfslick/react/dist/pdf_viewer.css';

import MarketAttachments from '@/services/MarketAttachmentService';

interface AttachmentProps {
    fileName: string;
    className: string;
}

const PDFViewerInner = ({ fileUrl }: { fileUrl: string }) => {
    const { viewerRef, usePDFSlickStore, PDFSlickViewer } = usePDFSlick(fileUrl, {
        singlePageViewer: false,
        scaleValue: "page-width",
    });
    return <PDFSlickViewer {...{ viewerRef, usePDFSlickStore }} />;
};

export const MarketAttachment = (props: AttachmentProps) => {
    const [base64UrlImage, setBase64UrlImage] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        MarketAttachments.getMarketBlobAttachment(props.fileName)
            .then((response: any) => {
                const file = new Blob([response.data], { type: response.headers['content-type'] });
                setBase64UrlImage(URL.createObjectURL(file));
            })
            .finally(() => setIsLoading(false));
    }, [props.fileName]);

    return (
        <>
            {isLoading ? (
                <div className="spinner-container">
                    <Spinner size={SpinnerSize.large} className="button-spinner" />
                </div>
            ) : (
                props.fileName.endsWith(".pdf") ? (
                    <div style={{ position: 'relative', flex: 1, width: '100%', minHeight: '1300px' }}>
                        <PDFViewerInner fileUrl={base64UrlImage} />
                    </div>
                ) : (
                    <img src={base64UrlImage} className={props.className} alt="Cargando..." />
                )
            )}
        </>
    );
};
